export const fmtUsd = (v, digits = 2) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return v.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits });
};

export const fmtNum = (v, digits = 2) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  return v.toLocaleString("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits });
};

export const fmtPct = (v, digits = 2) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toFixed(digits)}%`;
};

let TZ = (typeof localStorage !== "undefined" && localStorage.getItem("kalki_tz")) || "UTC";
export const getTz = () => TZ;
export const setTz = (t) => { TZ = t; try { localStorage.setItem("kalki_tz", t); } catch {} };

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const opts = { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: false };
    if (TZ === "UTC") return new Date(iso).toLocaleString("en-US", { ...opts, timeZone: "UTC" }) + " UTC";
    return new Date(iso).toLocaleString("en-US", opts) + " Local";
  } catch (error) {
    console.error("fmtDate failed:", error);
    return iso;
  }
};

export const relTime = (iso) => {
  if (!iso) return "Never";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  return `${days}d ago`;
};

export const pnlColor = (v) => (v > 0 ? "text-[#10B981]" : v < 0 ? "text-[#EF4444]" : "text-[#A3A3A3]");

export const fmtCompactUsd = (v) => {
  if (v === null || v === undefined || Number.isNaN(v)) return "—";
  const abs = Math.abs(v);
  if (abs >= 1000) return `$${(v / 1000).toFixed(1)}K`;
  return `$${v.toFixed(1)}`;
};
